import styled from "styled-components";

const Container = styled.div`
    position: fixed;
    align-items: center;
    z-index: 20;
    width: 100%;
    margin-top: -8rem;
    padding-top: 8rem;
    height: 100%;
    background-color: var(--overlay);
`;

const Modal = styled.div`
    margin: 7% auto;
    background-color: var(--modal-background);
    border: 1px solid var(--border-soft);
    max-width: 530px;
    padding: 0;
    z-index: 10;
    height: 55vh;
    border-radius: 8px;
    overflow-y: scroll;

    opacity: 0;
    transform: scale(0.95);
    transition:
        opacity 0.3s ease,
        transform 0.3s ease;

    &.active {
        opacity: 1;
        transform: scale(1);
    }

    header {
        max-width: 90%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    header h2 {
        font-size: 1.125rem;
    }

    header button {
        border: none;
        background-color: transparent;
        font-size: 1.56rem;
        color: var(--text-muted);
        cursor: pointer;
    }

    main {
        margin: 0 auto;
        padding: 15px 25px;
        opacity: 0;
        transition: opacity 0.4s ease;
    }

    &.active main {
        opacity: 1;
    }

    img {
        display: block;
        margin: auto;
        max-width: 15rem;
        max-height: 7rem;
        border-radius: 8px;
        background-color: var(--project-background);
    }

    main h2 {
        font-weight: 500;
        font-size: 1rem;
    }

    main p {
        font-weight: 400;
        font-size: 0.875rem;
    }

    main button {
        background-color: transparent;
        border-radius: 8px;
        cursor: pointer;
        margin: 10px 0;
        padding: 15px;
        color: var(--black);
        border: 0.5px solid var(--border-soft);
    }

    main button:hover {
        color: var(--hover-text);
        border: 0.5px solid var(--hover-border);
        background-color: var(--hover-background);
    }

    .square2 {
        display: flex;
        flex-direction: column;
    }

    .buttons {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
    }

    @media (max-width: 725px) {
        h1 {
            font-size: 1.25rem;
        }
        max-width: 85%;
    }
`;
export { Container, Modal };
